import { cn } from '@leoclinic/ui';
import { useClinicPortal } from '@/providers/clinic-provider';

const DEFAULT_LOGO = '/app-logo.svg?v=lc3';

const SIZE_CLASS = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-14 w-14',
} as const;

/** URLs antigas (Terapia do Toque / uploads legados) — ignorar e usar logo LC */
function isLegacyBrandingUrl(url: string): boolean {
  const lower = url.toLowerCase();
  return (
    lower.includes('terapia') ||
    lower.includes('terapiadotoque') ||
    lower.includes('heloisa') ||
    lower.includes('terapia-do-toque')
  );
}

function resolveLogoUrl(customUrl: string | null | undefined): string {
  if (customUrl?.trim() && !isLegacyBrandingUrl(customUrl)) return customUrl;
  return DEFAULT_LOGO;
}

interface ClinicLogoProps {
  size?: keyof typeof SIZE_CLASS;
  className?: string;
}

/** Logo do portal cliente — personalizável em Definições admin */
export function ClinicLogo({ size = 'md', className }: ClinicLogoProps) {
  const { clinic } = useClinicPortal();
  const logoUrl = resolveLogoUrl(clinic?.logoUrl);

  return (
    <img
      src={logoUrl}
      alt={clinic?.name ?? ''}
      className={cn('shrink-0 object-contain', SIZE_CLASS[size], className)}
    />
  );
}
